// Scheda della chiamata in arrivo dalla barra Tempest.
//
// Alle chiamate delle campagne il gestionale allega l'identificativo della
// scheda nel campo field9 del record, nella forma tipo:id (es. "lead:37949").
// La barra lo restituisce nell'evento phone_ring_in, dentro var_info: una
// lista di variabili della chiamata, dove l'identificativo e' quella con
// VarName "api_lead" (VarDesc "lead"). Con quello la scheda giusta si conosce
// senza passare dal numero, che puo' stare su piu' anagrafiche.

// Codici business delle anagrafiche, come in eventBusUtility.businessRouteName
const BUSINESS_PER_TIPO = {
	company: 0,
	supplier: 1,
	lead: 2,
	prospect: 3,
}

// Variabile della barra che porta l'identificativo della scheda
function variabileLead(elemento) {
	if (!elemento || typeof elemento !== 'object') {
		return false
	}

	return elemento.VarName === 'api_lead'
		|| String(elemento.VarDesc || '').toLowerCase() === 'lead'
}

// Il formato della barra e' la lista di variabili; come ripiego si accettano
// anche un oggetto con la chiave "lead" e il testo JSON di una delle due forme.
// Il resto non e' un identificativo
function valoreLead(varInfo) {
	if (typeof varInfo === 'string') {
		try {
			return valoreLead(JSON.parse(varInfo))
		} catch (e) {
			return null
		}
	}

	if (Array.isArray(varInfo)) {
		const variabile = varInfo.find(variabileLead)

		if (variabile) {
			return variabile.VarValue
		}

		const voce = varInfo.find(elemento => elemento && typeof elemento === 'object' && elemento.lead)
		return voce ? voce.lead : null
	}

	if (varInfo && typeof varInfo === 'object') {
		return varInfo.lead || null
	}

	return null
}

/**
 * Scheda indicata dall'evento della barra, o null se l'evento non la porta.
 *
 * @param {*} varInfo  il campo var_info dell'evento phone_ring_in
 * @returns {{tipo: string, id: number, business: number}|null}
 */
export function schedaDellaChiamata(varInfo) {
	const valore = valoreLead(varInfo)
	const parti = String(valore || '').trim().match(/^([a-z]+):(\d+)$/i)

	if (!parti) {
		return null
	}

	const tipo = parti[1].toLowerCase()
	const id = Number(parti[2])

	if (!(tipo in BUSINESS_PER_TIPO) || !id) {
		return null
	}

	return { tipo, id, business: BUSINESS_PER_TIPO[tipo] }
}

/**
 * Anagrafiche da proporre all'operatore: quella indicata dalla barra in cima e
 * segnata come scheda della chiamata, poi le altre trovate per numero. Se la
 * ricerca per numero non l'ha trovata (numero cambiato, ricerca fallita) la si
 * propone comunque, senza nome.
 *
 * @param {Array} trovate  risultati di business-by-phone
 * @param {Object|null} scheda  risultato di schedaDellaChiamata
 * @param {string|null} numero  numero annunciato dalla barra
 * @returns {Array}
 */
export function propostePerChiamata(trovate, scheda, numero) {
	const elenco = Array.isArray(trovate) ? trovate : []

	if (!scheda) {
		return elenco
	}

	const stessa = match => Number(match.business) === scheda.business && Number(match.id) === scheda.id
	const indicata = elenco.find(stessa)

	return [
		Object.assign({
			id: scheda.id,
			business: scheda.business,
			tipo: scheda.tipo,
			nome: 'Scheda della chiamata',
			telefono: numero,
		}, indicata || {}, { esatta: true }),
		...elenco.filter(match => !stessa(match)),
	]
}
